import React from 'react';

const SectionHeader = ({ num, tag, title, color = '#F97316' }) => (
  <div style={{ marginBottom: '36px', position: 'relative' }}>
    <div
      style={{
        fontFamily: 'Impact, sans-serif',
        fontSize: 'clamp(4rem, 10vw, 8rem)',
        fontWeight: 900,
        color: `${color}08`,
        lineHeight: 1,
        position: 'absolute',
        top: '-20px',
        left: '-10px',
        userSelect: 'none',
        letterSpacing: '-0.04em'
      }}
    >
      {num}
    </div>
    <div style={{ position: 'relative', zIndex: 1 }}>
      <div
        style={{
          fontFamily: 'JetBrains Mono, monospace',
          fontSize: '0.6875rem',
          color: color,
          letterSpacing: '0.15em',
          textTransform: 'uppercase',
          marginBottom: '8px'
        }}
      >
        {tag}
      </div>
      <h2
        style={{
          fontFamily: 'Impact, sans-serif',
          fontSize: 'clamp(1.5rem, 3.5vw, 2.75rem)',
          fontWeight: 900,
          color: '#EEF0F2',
          textTransform: 'uppercase',
          letterSpacing: '-0.02em',
          lineHeight: 1
        }}
      >
        {title}
      </h2>
    </div>
  </div>
);

const BodyText = ({ children }) => (
  <p
    style={{
      fontFamily: 'Georgia, serif',
      fontSize: '1rem',
      color: 'rgba(238,240,242,0.72)',
      lineHeight: 1.85,
      marginBottom: '20px',
      maxWidth: '760px'
    }}
  >
    {children}
  </p>
);

const Divider = ({ color = '#F97316' }) => (
  <div style={{ margin: '48px 0', display: 'flex', alignItems: 'center', gap: '16px' }}>
    <div style={{ flex: 1, height: '1px', background: 'rgba(255,255,255,0.06)' }} />
    <div style={{ width: '8px', height: '8px', background: color, transform: 'rotate(45deg)' }} />
    <div style={{ flex: 1, height: '1px', background: 'rgba(255,255,255,0.06)' }} />
  </div>
);

const LiabilityWarrantySection = () => {
  return (
    <>
      {/* Section 7: User Content */}
      <section id="brukerinnhold" style={{ marginBottom: '80px' }}>
        <SectionHeader
          num="07"
          tag="§ 7 — BRUKERINNHOLD & DATA"
          title="Brukerinnhold & data"
          color="#3B6FD4"
        />
        <BodyText>
          Ved å laste opp eller dele innhold på NordPass-plattformen, gir du NordPass en ikke-eksklusiv, verdensomspennende, royalty-fri lisens til å bruke, reprodusere og vise slikt innhold i forbindelse med tjenesteleveransen.
        </BodyText>
        <div
          style={{
            background: 'rgba(59,111,212,0.06)',
            border: '1px solid rgba(59,111,212,0.2)',
            borderLeft: '4px solid #3B6FD4',
            padding: '24px',
            marginBottom: '24px'
          }}
        >
          <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.75rem', fontWeight: 700, color: '#3B6FD4', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '10px' }}>Du bekrefter at ditt innhold:</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {[
              'Ikke krenker tredjeparts immaterielle rettigheter',
              'Ikke inneholder ulovlig, skadelig eller støtende materiale',
              'Er nøyaktig og ikke villedende',
              'Overholder alle gjeldende norske lover og forskrifter',
            ]?.map((item, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                <div style={{ width: '6px', height: '6px', background: '#3B6FD4', borderRadius: '50%', marginTop: '7px', flexShrink: 0 }} />
                <span style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.875rem', color: 'rgba(238,240,242,0.72)', lineHeight: 1.6 }}>{item}</span>
              </div>
            ))}
          </div>
        </div>
        <BodyText>
          NordPass forbeholder seg retten til å fjerne innhold som bryter disse vilkårene uten forhåndsvarsel. Personopplysninger behandles i henhold til vår Personvernerklæring.
        </BodyText>
      </section>

      <Divider color="#3B6FD4" />

      {/* Section 8: Liability */}
      <section id="ansvarsbegrensning" style={{ marginBottom: '80px' }}>
        <SectionHeader
          num="08"
          tag="§ 8 — ANSVARSBEGRENSNING"
          title="Ansvarsbegrensning"
          color="#EF4444"
        />
        <div
          style={{
            background: 'rgba(239,68,68,0.08)',
            border: '2px solid rgba(239,68,68,0.3)',
            padding: '32px',
            marginBottom: '28px',
            position: 'relative',
            transform: 'rotate(-0.3deg)'
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '-14px',
              left: '24px',
              background: '#EF4444',
              padding: '4px 12px',
              fontFamily: 'Impact, sans-serif',
              fontSize: '0.75rem',
              color: '#fff',
              letterSpacing: '0.1em'
            }}
          >
            VIKTIG JURIDISK KLAUSUL
          </div>
          <p style={{ fontFamily: 'Georgia, serif', fontSize: '1rem', color: 'rgba(238,240,242,0.8)', lineHeight: 1.8, margin: 0 }}>
            I den grad det er tillatt etter norsk lov, er NordPass AS sitt totale ansvar overfor deg begrenset til det beløpet du har betalt for tjenestene i de siste 12 månedene. NordPass er ikke ansvarlig for indirekte tap, følgeskader, tapte inntekter, tapte data eller forretningsmessige tap.
          </p>
        </div>
        <BodyText>
          NordPass er ikke ansvarlig for tap som skyldes: (a) feil i tredjeparts data eller tjenester; (b) nettverksavbrudd eller tekniske feil utenfor vår kontroll; (c) din bruk av tjenestene i strid med disse vilkårene; (d) force majeure-hendelser.
        </BodyText>
        <BodyText>
          Ansvarsbegrensningene gjelder ikke for personskade, grov uaktsomhet, forsettlig skadeforvoldelse, eller der norsk lov forbyr slike begrensninger.
        </BodyText>
      </section>

      <Divider color="#EF4444" />

      {/* Section 9: Warranty */}
      <section id="garanti" style={{ marginBottom: '80px' }}>
        <SectionHeader
          num="09"
          tag="§ 9 — GARANTIFRASKRIVELSE"
          title="Garantifraskrivelse"
          color="#8B5CF6"
        />
        <BodyText>
          Tjenestene leveres «som de er» og «som tilgjengelig» uten noen form for garanti, verken uttrykkelig eller underforstått. NordPass fraskriver seg, i den grad norsk lov tillater det, alle garantier, inkludert men ikke begrenset til:
        </BodyText>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '12px', marginBottom: '28px' }}>
          {[
            { title: 'Nøyaktighet', desc: 'Vi garanterer ikke at bomavgiftsberegninger eller veikartdata er 100% nøyaktige til enhver tid.' },
            { title: 'Tilgjengelighet', desc: 'Vi garanterer ikke uavbrutt tilgang til tjenestene. Planlagt og uplanlagt vedlikehold kan forekomme.' },
            { title: 'Egnethet', desc: 'Vi garanterer ikke at tjenestene er egnet for dine spesifikke formål eller behov.' },
            { title: 'Sikkerhet', desc: 'Selv om vi tar sikkerhet på alvor, kan vi ikke garantere at tjenestene er fri for sikkerhetssårbarheter.' },
          ]?.map((item, i) => (
            <div
              key={i}
              style={{
                background: 'rgba(139,92,246,0.06)',
                border: '1px solid rgba(139,92,246,0.15)',
                padding: '20px'
              }}
            >
              <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.8125rem', fontWeight: 700, color: '#8B5CF6', marginBottom: '8px' }}>{item?.title}</div>
              <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: 'rgba(238,240,242,0.6)', lineHeight: 1.6 }}>{item?.desc}</div>
            </div>
          ))}
        </div>
      </section>

      <Divider color="#8B5CF6" />

      {/* Section 10: Service Availability */}
      <section id="tilgjengelighet" style={{ marginBottom: '80px' }}>
        <SectionHeader
          num="10"
          tag="§ 10 — TJENESTETILGJENGELIGHET"
          title="Tjenestetilgjengelighet & endringer"
          color="#10B981"
        />
        <BodyText>
          NordPass tilstreber 99,5% oppetid for betalte abonnementer. Planlagt vedlikehold varsles med minimum 24 timers varsel via e-post og på vår statusside. Uplanlagte avbrudd vil bli kommunisert så snart som mulig.
        </BodyText>
        <div
          style={{
            background: 'rgba(16,185,129,0.06)',
            border: '1px solid rgba(16,185,129,0.2)',
            padding: '24px',
            marginBottom: '24px'
          }}
        >
          <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.75rem', fontWeight: 700, color: '#10B981', letterSpacing: '0.1em', textTransform: 'uppercase', marginBottom: '12px' }}>SLA — Tjenestenivåavtale (Premium)</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
            {[
              { metric: '99,5%', label: 'Garantert oppetid' },
              { metric: '< 4t', label: 'Responstid ved kritiske feil' },
              { metric: '24/7', label: 'Overvåking av tjenester' },
            ]?.map((m, i) => (
              <div key={i} style={{ textAlign: 'center' }}>
                <div style={{ fontFamily: 'Impact, sans-serif', fontSize: '1.5rem', color: '#10B981', letterSpacing: '0.02em' }}>{m?.metric}</div>
                <div style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.75rem', color: 'rgba(138,149,163,0.7)', marginTop: '4px' }}>{m?.label}</div>
              </div>
            ))}
          </div>
        </div>
        <BodyText>
          NordPass forbeholder seg retten til å endre, oppdatere eller avvikle tjenester med 30 dagers varsel til betalende abonnenter. Vesentlige endringer som påvirker kjernetjenestene vil gi rett til å si opp abonnementet uten gebyr.
        </BodyText>
      </section>

      <Divider color="#10B981" />

      {/* Section 11: Termination */}
      <section id="oppsigelse" style={{ marginBottom: '80px' }}>
        <SectionHeader
          num="11"
          tag="§ 11 — OPPSIGELSE & SUSPENSJON"
          title="Oppsigelse & kontosuspensjon"
          color="#F97316"
        />
        <BodyText>
          Begge parter kan avslutte avtaleforholdet. Du kan slette kontoen din når som helst via kontoinnstillingene. NordPass kan suspendere eller avslutte din konto ved brudd på disse vilkårene.
        </BodyText>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '28px' }}>
          <div style={{ background: 'rgba(16,185,129,0.06)', border: '1px solid rgba(16,185,129,0.2)', borderTop: '3px solid #10B981', padding: '20px' }}>
            <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.8125rem', fontWeight: 700, color: '#10B981', marginBottom: '12px' }}>Oppsigelse av bruker</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              {['Kanseller abonnement i Min konto', 'Kontoen forblir aktiv til periodens slutt', 'Data slettes etter 90 dager', 'Eksporter data før sletting']?.map((t, i) => (
                <div key={i} style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: 'rgba(238,240,242,0.65)', display: 'flex', gap: '8px' }}>
                  <span style={{ color: '#10B981' }}>→</span> {t}
                </div>
              ))}
            </div>
          </div>
          <div style={{ background: 'rgba(239,68,68,0.06)', border: '1px solid rgba(239,68,68,0.2)', borderTop: '3px solid #EF4444', padding: '20px' }}>
            <div style={{ fontFamily: 'Syne, sans-serif', fontSize: '0.8125rem', fontWeight: 700, color: '#EF4444', marginBottom: '12px' }}>Suspensjon av NordPass</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              {['Brudd på vilkår eller norsk lov', 'Svikaktig aktivitet eller misbruk', 'Manglende betaling etter 30 dager', 'Trusler mot andre brukere']?.map((t, i) => (
                <div key={i} style={{ fontFamily: 'Inter, sans-serif', fontSize: '0.8125rem', color: 'rgba(238,240,242,0.65)', display: 'flex', gap: '8px' }}>
                  <span style={{ color: '#EF4444' }}>!</span> {t}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LiabilityWarrantySection;
